<button type="button" class="button button--blue-tertiary" [tabindex]="0" (click)="openTooltipDialog()" 
        attr.aria-label="{{ 'aria.label.info.button' | translate | async }}">
  <mat-icon class="mat-icon--text">info</mat-icon>
</button>
